import styled from "styled-components";
import PushBackIcon from "../../../assets/icons/PushBackIcon";

//p/ 1080p -> 1.35rem
//p/ 720p -> 1rem
//? Considerando os valores para 720p
export const Container = styled.div`
  font-family: Sora;
  display: flex;
  background: #585e66;
  //min-width: 32.3425rem; //517px
  padding-right: 1.625rem;
  height: 3.763rem; //60.24px
  align-items: center;
  user-select: none;
  border-radius: 0.18125rem;

  //******************** */
  position: absolute;
  top: 0.3125rem;
  z-index: 5;
`;
export const LogoZaivu = styled.img`
  width: 5.82375rem; //93.18px
  height: 1.52375rem; //24.38px
  margin-left: 1.2rem;
  user-select: none;
`;

export const Input = styled.input`
  font-family: Sora;
  font-size: 0.705625rem; //11.29px;
  color: #eff1f5;
  width: calc(12.765rem + 1.4375rem);
  height: 2rem; //32px;
  font-weight: 600;
  background: none;
  line-height: 1.329375rem;
  border: 1.2px solid #40e5a0;
  box-sizing: border-box;
  outline: none;
  padding: 0.63325rem 0 0.545rem 0.921875rem;

  ::selection {
    background: #40e5a0;
  }

  border-radius: 0.352375rem; //5.64746px;
`;

export const ContentName = styled.div`
  margin-left: 2rem;
  height: 100%;
  display: flex;
`;
export const ProjectName = styled.div`
  display: flex;
  align-items: center;
  width: ${({ AdvancedStats }) =>
    AdvancedStats === true ? "21.6rem" : "13.765rem"};
  height: 100%;

  p {
    font-size: 0.705625rem; //11.29px
    color: #fff;
    line-height: 1rem;
    font-weight: 600;
    overflow-wrap: break-word;
    word-wrap: break-word;
    width: 90%;

    padding: 0.63325rem 0 0.545rem 0.921875rem;
  }
  .uniqueTitle {
    color: #40e5a0;
    padding: 0.63325rem 0 0.545rem 0;
  }
  .uniqueText {
    width: 16.5rem;
  }

  svg {
    height: 2.110625rem;
  }
`;

export const IconDiv = styled.div`
  display: flex;
  align-items: center;
  margin-left: 0.6875rem;
  width: 1.4375rem; //23px
  z-index: 50;
  cursor: pointer;
`;

export const VerticalLine = styled.div`
  width: 0px;
  height: 80%;
  background: #7e858f;
  margin-left: 1.1rem; //17.6px

  border: 0.541243px solid #7e858f;
`;

export const CheckButton = styled.div`
  cursor: pointer;
  height: 100%;
  width: 1.44375rem;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  
  
`;